import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { OFFER_PARAM } from '.';

const SUBSCRIBE_TODAY = 'Subscribe today';
interface HeaderProps {
  isSubscriber: boolean;
}

const Header = ({ isSubscriber }: HeaderProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <header className="mb-48 flex w-full items-center justify-center gap-16 md:mb-64">
      <div className="flex w-full max-w-[640px] flex-col items-center text-center md:max-w-[766px]">
        <LogoTIWithIconTI
          className="h-[57px] w-full max-w-[242px]"
          aria-label="The Information logo"
        />
        <h1 className="m-0 mt-32 font-suisse-works text-headline-sm sm:text-headline-md">
          Award-winning finance coverage read by the industry’s most important decision makers.
        </h1>
        <p className="m-0 max-w-[616px] font-suisse-intl text-button-lg font-light">
          The Information’s finance bureau provides industry-leading reporting on deals and
          dealmakers along with financial analysis of public and private companies that you won’t
          find anywhere else.
        </p>
        {!isSubscriber && (
          <PrimaryButton
            className="mt-32 !w-[340px] px-36 py-12"
            as="link"
            href={subscribe_path({ offer: OFFER_PARAM })}
            onClickCapture={() =>
              trackEvent(click({ clickTarget: ClickTarget.Subscribe, clickText: SUBSCRIBE_TODAY }))
            }
          >
            {SUBSCRIBE_TODAY}
          </PrimaryButton>
        )}
      </div>
    </header>
  );
};

export default Header;
